import { Button, Checkbox, Col, Row } from 'antd';
import React, { ReactElement, useState } from 'react';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { GUTTOR_SPACE, INVENTROY_CONSTANTS } from '../../../../shared/constants/commonConstants';
import { extractSecondLevelBaseUrl } from './../../../../utils/utility';
import HealthCheckPackageForm from './HealthCheckPackageForm';

const NewHealthCheckPackage = ({ match: { path } }: any): ReactElement => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [isFinalSubmit, setIsFinalSubmit] = useState(false);
  const [isMaster, setIsMaster] = useState(false);
  const [disbaleCheckbox, setDisbaleCheckbox] = useState(false);

  const onFormSubmit = async (payload?: any): Promise<any> => {
    if (isSubmit) {
      setIsSubmit(false);
      setIsFinalSubmit(true);
    } else {
      setIsSubmit(true);
      setIsFinalSubmit(false);
    }
  };

  return (
    <div>
      <PageHeader
        backUrl={extractSecondLevelBaseUrl(path) + INVENTROY_CONSTANTS.hcPackageRoute}
        pageTitle="New Package"
        rightComponent={
          (): ReactElement =>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={24} className="flx-center">
                <div className="text-left">
                  <Checkbox disabled={disbaleCheckbox}
                    checked={isMaster} onChange={(): any => setIsMaster(!isMaster)}>Is master package ?</Checkbox>
                </div>
                <div className="text-right">

                  <Button className="btn-form-submit" type="link" onClick={onFormSubmit}> Submit
                  </Button>
                </div>
              </Col>
            </Row>}
      />
      <div className="ant-tabs-content-holder tab-custom-container">
        <HealthCheckPackageForm isSubmit={isSubmit}
          isMaster={isMaster} onMasterSelect={(): void => { setIsMaster(false); setDisbaleCheckbox(true); }}
          isFinalSubmit={isFinalSubmit} path={path} isNewPackage={true} />
      </div>
    </div>
  );
};

export default NewHealthCheckPackage;
